module.exports = __webpack_public_path__ + "4f6a031d3715fa17c40977163a2cd8c3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/btnCallStart.png
// module id = tQoh
// module chunks = 27